/**
 * Import List
 */
import React, { useState, useRef, useEffect } from "react";
import Calendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import momentPlugin from "@fullcalendar/moment";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { openAlert, openConfirm, closeAlert } from "redux/slices/alertSlice";
import { updateCalendarRange } from "redux/slices/calendarRangeSlice";
import style from "css/calendar.module.css";
import moment from "moment";
import "moment/locale/ko";
import dayjs from "dayjs";
import "dayjs/locale/ko";
// import locale from "antd/lib/locale/ko_KR";
import { Button, ConfigProvider, DatePicker, Segmented } from "antd";
import { ReactComponent as CalendarIcon } from "asset/calendar/calendar.svg";
import { ReactComponent as MeetingRoom } from "asset/calendar/meetingRoom.svg";
import { ReactComponent as Prev } from "asset/calendar/prev.svg";
import { ReactComponent as Next } from "asset/calendar/next.svg";
import { ReactComponent as MeetingNow } from "asset/calendar/meetingNow.svg";
import { useTranslation } from "react-i18next";

/**
 * Version : 1.0
 * 파일명 : CalendarItem.js
 * 작성일자 : 2023-04-13
 * 작성자 : 강연승
 * 설명 : 풀캘린더
 * 작성일자 : 2023-04-13
 * 수정자 : 강연승
 * 수정내역 :
 */
function FullCalendar(props) {
  // moment.locale("ko");
  const { t, i18n } = useTranslation();

  const navigate = useNavigate();
  //dispatch
  const dispatch = useDispatch();
  //useSelector
  const meetingTimePayload = useSelector((state) => state.meetingTime);
  //ref
  const calendarRef = useRef();
  //state
  const [calendarApi, setCalendarApi] = useState();
  const [titleMonth, setTitleMonth] = useState(dayjs());
  const [title, setTitle] = useState("");
  const [calendarViewType, setCalendarViewType] = useState("timeGridWeek");

  const dayConverter = (value) => {
    if (i18n.language === "en-US") {
      return moment(value).locale("en").format("ddd");
    } else {
      return moment(value).locale("ko").format("dd");
    }
  };
  const timeConverter = (value) => {
    if (i18n.language === "en-US") {
      return moment(value).locale("en").format("hh:mm A");
    } else {
      return moment(value).locale("ko").format("a hh:mm");
    }
  };
  const localeConverter = () => {
    if (i18n.language === "en-US") {
      return "en";
    } else {
      return "ko";
    }
  };

  //캘린더 이동 - 이전
  /* eslint-disable no-useless-escape */
  const calendarMovePrev = () => {
    calendarApi.prev();
    setTitle(
      moment(calendarApi.view.currentStart).locale("en").format("MMMM YYYY")
    );
    setTitleMonth(dayjs(calendarApi.view.currentStart));
    // setTitle(calendarApi.view.title);
    let start = moment(calendarApi.view.activeStart).format("YYYY-MM-DD");
    let end = moment(calendarApi.view.activeEnd).format("YYYY-MM-DD");

    const obj = {
      VIEW_TYPE: calendarApi.view.type,
      ACTIVE_START: start,
      ACTIVE_END: end,
    };
    dispatch(updateCalendarRange(obj));
  };

  //캘린더 이동 - 다음
  /* eslint-disable no-useless-escape */
  const calendarMoveNext = () => {
    calendarApi.next();
    // setTitle(calendarApi.view.title);
    setTitle(
      moment(calendarApi.view.currentStart).locale("en").format("MMMM YYYY")
    );
    setTitleMonth(dayjs(calendarApi.view.currentStart));
    let start = moment(calendarApi.view.activeStart).format("YYYY-MM-DD");
    let end = moment(calendarApi.view.activeEnd).format("YYYY-MM-DD");
    const obj = {
      VIEW_TYPE: calendarApi.view.type,
      ACTIVE_START: start,
      ACTIVE_END: end,
    };
    dispatch(updateCalendarRange(obj));
  };

  const calendarMoveMonth = (month) => {
    calendarApi.changeView(calendarApi.view.type, month);
    setTitle(
      moment(calendarApi.view.currentStart).locale("en").format("MMMM YYYY")
    );
    // setTitleMonth(
    //   dayjs(calendarApi.view.currentStart)
    // );
    // setTitle(calendarApi.view.title);
    let start = moment(calendarApi.view.activeStart).format("YYYY-MM-DD");
    let end = moment(calendarApi.view.activeEnd).format("YYYY-MM-DD");
    const obj = {
      VIEW_TYPE: calendarApi.view.type,
      ACTIVE_START: start,
      ACTIVE_END: end,
    };
    dispatch(updateCalendarRange(obj));
  };

  const calendarClickDate = (date) => {
    calendarApi.changeView("timeGridWeek", date);
    setTitle(
      moment(calendarApi.view.currentStart).locale("en").format("MMMM YYYY")
    );
    // setTitle(calendarApi.view.title);
    setCalendarViewType(calendarApi.view.type);
    let start = moment(calendarApi.view.activeStart).format("YYYY-MM-DD");
    let end = moment(calendarApi.view.activeEnd).format("YYYY-MM-DD");
    const obj = {
      VIEW_TYPE: calendarApi.view.type,
      ACTIVE_START: start,
      ACTIVE_END: end,
    };
    dispatch(updateCalendarRange(obj));
  };

  //캘린더 이동 - 오늘
  /* eslint-disable no-useless-escape */
  //   const calendarMoveToday = () => {
  //     calendarApi.today();
  //     setTitle(calendarApi.view.title);
  // //moment format 사용
  // let start = moment(calendarApi.view.activeStart).format("YYYY-MM-DD");
  // let end = moment(calendarApi.view.activeEnd).format("YYYY-MM-DD");
  //     const obj = {
  //       VIEW_TYPE: calendarApi.view.type,
  //       ACTIVE_START: start,
  //       ACTIVE_END: end,
  //     };
  //     dispatch(updateCalendarRange(obj));
  //   };

  //캘린더 뷰 타입 변경
  const changeViewType = (type) => {
    if (type === calendarApi.view.type) {
      return;
    }
    if (type === "dayGridMonth" && calendarApi.view.type === "timeGridWeek") {
      calendarApi.changeView("dayGridMonth");
    } else if (
      type === "timeGridWeek" &&
      calendarApi.view.type === "dayGridMonth"
    ) {
      calendarApi.changeView("timeGridWeek", moment().format());
    }
    setTitle(
      moment(calendarApi.view.currentStart).locale("en").format("MMMM YYYY")
    );
    // setTitle(calendarApi.view.title);
    setCalendarViewType(calendarApi.view.type);
    let activeStart = moment(calendarApi.view.activeStart).format("YYYY-MM-DD");
    let activeEnd = moment(calendarApi.view.activeEnd).format("YYYY-MM-DD");
    const obj = {
      VIEW_TYPE: calendarApi.view.type,
      ACTIVE_START: activeStart,
      ACTIVE_END: activeEnd,
    };
    dispatch(updateCalendarRange(obj));
    //    props.setSchedules([]);
    //    props.getSchedules(start, end);
  };

  /* eslint-disable no-useless-escape */
  useEffect(() => {
    if (calendarRef !== undefined) {
      let calApi = calendarRef.current.getApi();
      setCalendarApi(calApi);
      setTitle(
        moment(calApi.view.currentStart).locale("en").format("MMMM YYYY")
      );
      setCalendarViewType(calApi.view.type);
      let activeStart = moment(calApi.view.activeStart).format("YYYY-MM-DD");
      let activeEnd = moment(calApi.view.activeEnd).format("YYYY-MM-DD");
      // // props.setSchedules([]);
      // // props.getSchedules(activeStart, activeEnd);
      const obj = {
        VIEW_TYPE: calApi.view.type,
        ACTIVE_START: activeStart,
        ACTIVE_END: activeEnd,
      };
      dispatch(updateCalendarRange(obj));
    }
  }, [calendarRef, dispatch]);

  useEffect(() => {
    if (calendarApi !== undefined) {
      let activeStart = moment(calendarApi.view.activeStart).format(
        "YYYY-MM-DD"
      );
      let activeEnd = moment(calendarApi.view.activeEnd).format("YYYY-MM-DD");
      const obj = {
        VIEW_TYPE: calendarApi.view.type,
        ACTIVE_START: activeStart,
        ACTIVE_END: activeEnd,
      };
      dispatch(updateCalendarRange(obj));
    }
  }, [calendarViewType, calendarApi, dispatch]);

  useEffect(() => {
    if (calendarApi !== undefined) {
      if (!meetingTimePayload.VIEW) {
        calendarApi.unselect();
      }
    }
  }, [meetingTimePayload.VIEW, calendarApi]);

  useEffect(() => {
    if (meetingTimePayload.TYPE === "CALENDAR") {
      return;
    }
    if (meetingTimePayload.VIEW) {
      if (meetingTimePayload.START_DATE !== "") {
        calendarApi.changeView("timeGridWeek", meetingTimePayload.START_DATE);
        if (meetingTimePayload.END_TIME !== "") {
          if (
            calendarApi.view.activeStart.toISOString() <
              meetingTimePayload.START_TIME &&
            meetingTimePayload.END_TIME <
              calendarApi.view.activeEnd.toISOString()
          ) {
            calendarApi.select({
              start:
                meetingTimePayload.START_DATE +
                "T" +
                meetingTimePayload.START_TIME,
              end:
                meetingTimePayload.END_DATE + "T" + meetingTimePayload.END_TIME,
            });
          } else {
            calendarApi.changeView(
              "timeGridWeek",
              meetingTimePayload.START_DATE
            );
            calendarApi.select({
              start:
                meetingTimePayload.START_DATE +
                "T" +
                meetingTimePayload.START_TIME,
              end:
                meetingTimePayload.END_DATE + "T" + meetingTimePayload.END_TIME,
            });
          }
        }
      }
    }
  }, [calendarApi, meetingTimePayload]);

  // useEffect(() => {
  //   console.log(dayjs(date, "YYYY-MM"))
  // }, [])

  return (
    <>
      <div className={style.header_toolbar}>
        <div className={style.btn_area}>
          <ConfigProvider
            theme={{
              components: {
                Button: {
                  colorPrimaryActive: "#1cb691",
                  colorPrimaryHover: "#1cb691",
                  fontFamily: "Spoqa Han Sans Neo",
                },
              },
            }}
          >
            <Button
              className={`${style.btn} ${style.unactive}`}
              icon={<MeetingRoom />}
              size="large"
              onClick={() => {
                // navigate(process.env.REACT_APP_CLIENT_URL + "app/meeting/room")
                props.setType("room");
              }}
            >
              {t("BTN.ROOM_STATUS")}
            </Button>
          </ConfigProvider>
          <ConfigProvider
            theme={{
              components: {
                Button: {
                  fontFamily: "Spoqa Han Sans Neo",
                  colorPrimary: "#1cb691",
                },
              },
            }}
          >
            <Button
              className={style.btn}
              icon={<CalendarIcon />}
              size="large"
              type="primary"
              // onClick={() =>
              //   navigate(
              //     process.env.REACT_APP_CLIENT_URL + "app/meeting/calendar"
              //   )
              // }
            >
              {t("BTN.CALENDAR")}
            </Button>
          </ConfigProvider>
        </div>
        <div className={style.title_area}>
          <button
            type="button"
            aria-pressed="false"
            className={style.prev_btn}
            onClick={calendarMovePrev}
          >
            {/* <img src="/icon/calendar/prev.png" alt="" /> */}
            <Prev />
          </button>

          <div className={style.month_picker}>
            <label htmlFor="MonthPicker">
              <div className={style.title}>{title}</div>
            </label>
            <ConfigProvider
              theme={{
                token: {
                  fontFamily: "Spoqa Han Sans Neo",
                },
              }}
            >
              <DatePicker
                // style={{ display: "none" }}
                id="MonthPicker"
                name="MonthPicker"
                picker="month"
                format={"MMMM YYYY"}
                bordered={false}
                value={titleMonth}
                className="month_picker"
                onChange={(date) => {
                  setTitleMonth(dayjs(date, "YYYY-MM"));
                  calendarMoveMonth(date.format("YYYY-MM"));
                }}
                inputReadOnly={true}
              />
            </ConfigProvider>
          </div>
          <button
            type="button"
            aria-pressed="false"
            className={style.next_btn}
            onClick={calendarMoveNext}
          >
            {/* <img src="/icon/calendar/next.png" alt="" /> */}
            <Next />
          </button>
        </div>
        <div className={style.view_type_btn_area}>
          <ConfigProvider
            theme={{
              token: {
                // colorFillSecondary: "#7b7b7b",
                // colorPrimaryHover: "#1cb691",
              },
              components: {
                Segmented: {
                  colorText: "#1cb691",
                  colorTextLabel: "#7b7b7b",
                  padding: 23,
                  fontFamily: "Spoqa Han Sans Neo",
                },
              },
            }}
          >
            <Segmented
              size="large"
              options={[
                { label: t("BTN.WEEK"), value: "timeGridWeek" },
                { label: t("BTN.MONTH"), value: "dayGridMonth" },
              ]}
              value={calendarViewType}
              onChange={changeViewType}
            />
          </ConfigProvider>
          <ConfigProvider
            theme={{
              components: {
                Button: {
                  colorPrimary: "#1cb691",
                  colorPrimaryHover: "#1AA886",
                  colorPrimaryActive: "#1cb691",
                  fontFamily: "Spoqa Han Sans Neo",
                },
              },
            }}
          >
            {/* <Button
              className={style.meeting_now_btn}
              type="primary"
              size="large"
              icon={<MeetingNow />}
              onClick={() => props.selectTime("")}
            >
              {t("BTN.INSTANT_MEETING")}
            </Button> */}
          </ConfigProvider>
        </div>
      </div>
      <div className={style.calendar}>
        <Calendar
          // schedulerLicenseKey="0736858632-fcs-1604369387"
          ref={calendarRef}
          plugins={[
            dayGridPlugin,
            timeGridPlugin,
            interactionPlugin,
            momentPlugin,
          ]}
          //  eventBackgroundColor={groupColor(props.groupColor)}
          //  eventBorderColor={groupColor(props.groupColor)}
          // initialView="dayGridMonth"
          initialView="timeGridWeek"
          timeZone="Asia/Seoul"
          locale={localeConverter()}
          // timeZone="UTC"
          // expansionRows={false}
          //  aspectRatio="1.207"
          expandRows={true}
          // fixedWeekCount={false}
          dayMaxEventRows={true}
          scrollTime={moment().subtract(60, "minutes").format("HH:mm:ss")}
          headerToolbar={false}
          // headerToolbar={{
          //   start: "prev today next",
          //   center: "title",
          //   end: "timeGridWeek,dayGridMonth",
          // }}
          views={{
            dayGridMonth: {
              titleFormat: "YYYY년 M월",
              dayPopoverFormat: "YYYY. M. D ",
              dateClick: function (e) {
                calendarClickDate(e.date);
              },
              displayEventTime: true,
              selectable: false, //사용자가 클릭하여 끌어서 여러 일 또는 시간대를 강조 표시하도록 허용.
              selectMirror: false, //드래그한 영역 표시
              dayHeaderContent: function (arg) {
                //요일 컨트롤
                return {
                  html:
                    "<div class='calendar-item-day-header'>" +
                    dayConverter(arg.date) +
                    "</div>",
                };
              },
              dayCellContent: function (arg) {
                //날짜 컨트롤
                return {
                  html:
                    "<div class='fc-daygrid-day-number'>" +
                    moment(arg.date).format("DD") +
                    "</div>",
                };
              },
              eventTimeFormat: {
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
              },
              eventContent: function (arg) {
                //스케줄 컨트롤
                const info = arg.event._def.extendedProps;
                return {
                  html:
                    "<div class='month-schedule'>" +
                    "<div class='scd-circle' style='background-color: " +
                    arg.borderColor +
                    "'></div>" +
                    "<div class='scd-time'>" +
                    timeConverter(info.START_TIME) +
                    "</div>" +
                    "<div style='color: #909090; margin-right: 8px'>|</div>" +
                    "<div class='scd-title'>" +
                    info.TITLE +
                    "</div>" +
                    "</div>",
                };
              },
              eventDrop: function (info) {
                info.revert();
                return;
              },
              eventResize: function (info) {
                info.revert();
                return;
              },
            },
            timeGridWeek: {
              titleFormat: "YYYY년 M월",
              titleRangeSeparator: " ~ ",
              selectable: true, //사용자가 클릭하여 끌어서 여러 일 또는 시간대를 강조 표시하도록 허용.
              selectMirror: true, //드래그한 영역 표시
              select: function (time) {
                if (time.end - time.start > 86400000) {
                  const obj = {
                    title: t("MESSAGE.NOTIFICATION"),
                    content: t("MESSAGE.OVER_24HOURS"),
                    submitEventHandler: () => {
                      dispatch(closeAlert());
                    },
                  };
                  dispatch(openAlert(obj));
                  calendarApi.unselect();
                  return;
                }
                if (new Date(time.startStr) < new Date()) {
                  const obj = {
                    title: t("MESSAGE.NOTIFICATION"),
                    content: t("MESSAGE.START_TIME_ERROR"),
                    submitEventHandler: () => {
                      dispatch(closeAlert());
                    },
                  };
                  dispatch(openAlert(obj));
                  calendarApi.unselect();
                  return;
                }
                props.selectTime(time);
              },
              //  dayCellClassNames: function (arg) {
              //    let year = arg.date.getFullYear();
              //    let mon =
              //      arg.date.getMonth() + 1 < 10
              //        ? "0" + (arg.date.getMonth() + 1)
              //        : arg.date.getMonth() + 1;
              //    let dt =
              //      arg.date.getDate() < 10
              //        ? "0" + arg.date.getDate()
              //        : arg.date.getDate();
              //    let dateString = year + "-" + mon + "-" + dt;
              //    if (DATEmeetingTimePayload.START_DATE === dateString) {
              //      return "selectDate";
              //    } else {
              //      return null;
              //    }
              //  },
              // titleFormat: function (info) {
              //     let year = info.date.year;
              //     let month = info.date.month + 1;
              //     let day = info.date.day;
              //     let date = new Date(year + "-" + month + "-" + day);
              //     let dayStrArr = [
              //       "일요일",
              //       "월요일",
              //       "화요일",
              //       "수요일",
              //       "목요일",
              //       "금요일",
              //       "토요일",
              //     ];
              //     let dayStr = dayStrArr[date.getDay()];
              //     return month + "월 " + day + "일 " + dayStr;
              //   },
              dayHeaderContent: function (arg) {
                return {
                  html:
                    "<div class='weekday'>" +
                    dayConverter(arg.date) +
                    "</div><div class='date'>" +
                    moment(arg.date).format("DD") +
                    "</div>",
                };
              },
              slotLabelFormat: {
                hour: "numeric",
                minute: "2-digit",
                hour12: false,
              },
              eventTimeFormat: {
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
              },
              eventDrop: function (info) {
                if (info.event.extendedProps.HOST_YN !== "Y") {
                  info.revert();
                  const obj = {
                    title: t("MESSAGE.NOTIFICATION"),
                    content: t("MESSAGE.INVITED_ROOM_MODIFY"),
                    submitEventHandler: () => dispatch(closeAlert()),
                  };
                  dispatch(openAlert(obj));
                  return;
                }

                if (
                  moment.utc(info.event.start).format("YYYY-MM-DD HH:mm:ss") <
                  moment().format("YYYY-MM-DD HH:mm:ss")
                ) {
                  info.revert();
                  return;
                }
                if (
                  moment
                    .utc(info.oldEvent.start)
                    .format("YYYY-MM-DD HH:mm:ss") <
                  moment().format("YYYY-MM-DD HH:mm:ss")
                ) {
                  info.revert();
                  return;
                }
                if (
                  moment.utc(info.oldEvent.end).format("YYYY-MM-DD HH:mm:ss") <
                    moment().format("YYYY-MM-DD HH:mm:ss") &&
                  moment.utc(info.event.start).format("YYYY-MM-DD HH:mm:ss") >
                    moment().format("YYYY-MM-DD HH:mm:ss")
                ) {
                  info.revert();
                  return;
                }

                const obj = {
                  title: t("MESSAGE.NOTIFICATION"),
                  content: t("MESSAGE.RSV_TIME_CHANGE_CONFIRM"),
                  submitEventHandler: () => {
                    dispatch(closeAlert());
                    props.saveEventDrop(info, "drop");
                  },
                  cancelEventHandler: () => {
                    info.revert();
                    dispatch(closeAlert());
                  },
                };
                dispatch(openConfirm(obj));
              },
              eventResize: function (info) {
                if (info.event.extendedProps.HOST_YN !== "Y") {
                  info.revert();
                  const obj = {
                    title: t("MESSAGE.NOTIFICATION"),
                    content: t("MESSAGE.INVITED_ROOM_MODIFY"),
                    submitEventHandler: () => dispatch(closeAlert()),
                  };
                  dispatch(openAlert(obj));
                  return;
                }

                // if (
                //   new Date(info.oldEvent.start)
                //     .toISOString()
                //     .replace(/\..*/, "") <
                //   new Date(
                //     new Date() * 1 + 3600000 * parseFloat(USER_STATE.OFFSET)
                //   )
                //     .toISOString()
                //     .replace(/\..*/, "")
                // ) {
                //   info.revert();
                //   return;
                // }
                // if (
                //   new Date(info.event.start).toISOString().replace(/\..*/, "") <
                //     new Date(
                //       new Date() * 1 + 3600000 * parseFloat(USER_STATE.OFFSET)
                //     )
                //       .toISOString()
                //       .replace(/\..*/, "") &&
                //   new Date(info.event.end).toISOString().replace(/\..*/, "") >
                //     new Date(
                //       new Date() * 1 + 3600000 * parseFloat(USER_STATE.OFFSET)
                //     )
                //       .toISOString()
                //       .replace(/\..*/, "")
                // ) {
                //   info.revert();
                //   return;
                // }

                // if (
                //   new Date(info.event.end).toISOString().replace(/\..*/, "") <
                //   new Date(
                //     new Date() * 1 + 3600000 * parseFloat(USER_STATE.OFFSET)
                //   )
                //     .toISOString()
                //     .replace(/\..*/, "")
                // ) {
                //   info.revert();
                //   return;
                // }

                const obj = {
                  title: t("MESSAGE.NOTIFICATION"),
                  content: t("MESSAGE.RSV_TIME_CHANGE_CONFIRM"),
                  submitEventHandler: () => {
                    dispatch(closeAlert());
                    props.saveEventDrop(info, "resize");
                  },
                  cancelEventHandler: () => {
                    info.revert();
                    dispatch(closeAlert());
                  },
                };
                dispatch(openConfirm(obj));

                // setAlertProps({
                //   ...alertProps,
                //   isShow: true,
                //   text: t("schedule.msg.editScheduleTime"),
                //   cancelBtnDisplay: true,
                //   okBtnEventHandler: function () {
                //     closeAlertEvent();
                //     props.saveEventDrop(info, "resize");
                //   },
                //   cancleBtnEventHandler: function () {
                //     closeAlertEvent();
                //     info.revert();
                //     return;
                //   },
                // });
              },
              //  viewDidMount: function (info) {
              //    if (info.view.type !== calendarViewType) {
              //      setCalendarViewType(info.view.type);
              //    }
              //    setTitle(info.view.title);
              //  },
              //  dayHeaderDidMount: function (info) {
              //    setTitle(info.view.title);
              //  },
            },
          }}
          slotDuration="00:10:00"
          eventClick={(e) => {
            props.eventClick(e.event.id);
          }}
          allDaySlot={false} //Week,day 일때 all-day 슬롯 표출 여부
          events={props.scheduleList}
          nowIndicator={true} //현재 시간을 나타내는 마커를 표시할지 여부.
          editable={true} // enable draggable events
          dragScroll={true}
          eventDurationEditable={true} //크기를 조정하여 이벤트 기간을 편집할 수 있도록 허용. 드래그로 크기조정
          eventStartEditable={true} //끌기를 통해 이벤트의 시작 시간을 편집할 수 있도록 허용. 드래그앤드랍
          selectOverlap={true} //사용자가 이벤트에 의해 점유되는 기간을 선택할 수 있는지 여부를 결정한다.
          unselectAuto={false} //페이지의 다른 곳을 클릭하면 현재 선택 항목이 지워지는지 여부.
        />
      </div>
    </>
  );
}

export default FullCalendar;
